import React from 'react'
import dayjs from 'dayjs'

type Props = {
  user: {
    lastActive: String,
    last_active: String,
    phone_characteristics: {
      app_version: String,
      phone_model: String,
    },
  },
}

const formatLastActive = (str) =>
  dayjs(str)
    .format('dddd DD/MM HH:mm')
    .split('')
    .map((s, i) => (i === 0 ? s.toUpperCase() : s))

const UserTrackingSummary = ({ user }: Props) => (
  <div>
    <div>Senast aktiv: {formatLastActive(user.lastActive || user.last_active)}</div>
    <div>Appversion: {user.phone_characteristics?.app_version}</div>
    <div>Telefonmodell: {user.phone_characteristics?.phone_model}</div>
  </div>
)

export default UserTrackingSummary
